import { useRecoilValue } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import {
  reportFilterGroupState,
  reportSearchTypeState,
  reportTelemetryState,
  reportViewState,
} from '../../../storage/reports';
import { FloatingCardContent } from '../../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../../layout/FloatingCardsLayout';
import { TelemetryReports } from '../../reports/telemetryReport/TelemetryReports';
import { TelemetryReportsByGroup } from '../../reports/telemetryReport/TelemetryReportsByGroup';
import ReportsSharedWrapper from './ReportsSharedWrapper';

function TelemetryReportsPage() {
  const { theme } = useStyles();
  const reportView = useRecoilValue(reportViewState);
  const reportSearchType = useRecoilValue(reportSearchTypeState);
  const groupId = useRecoilValue(reportFilterGroupState);
  const hasStates = !!useRecoilValue(reportTelemetryState(groupId))?.length;
  const isGroupReportView = reportSearchType === 1 && reportView === 0;

  return (
    <FloatingCardsLayout
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          <ReportsSharedWrapper>
            {!isGroupReportView && <TelemetryReports />}
            {isGroupReportView && <TelemetryReportsByGroup />}
          </ReportsSharedWrapper>
        </FloatingCardContent>
      }
      contentSize={isGroupReportView && hasStates ? 800 : 550}
    />
  );
}

export default TelemetryReportsPage;
